<template>
  <div class="about">
    <h1>A Site for Events to Better the World</h1>
    <p>{{ $store.state.organizer.name }}</p>
  </div>
</template>
